import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore'

export const useAnswerStore = defineStore('AnswerStore', {
  state: () => modelCollectionState('answers'),
  getters: { ...modelCollectionGetters('answers') },
  actions: {
    ...modelCollectionActions('answers'),
    getAnswersByQuestionId(questionId) {
      return this.answers
        .filter((answer) => answer.question_id === questionId)
        .sort((a, b) => a.position - b.position)
    },
  },
})
